import { Validators } from 'utils/validators';
import { FormModel } from 'components/Form';

export const EventDetailForm = (
  strings: any,
  lineItemsList: any[],
  layoutList: any[],
): FormModel[] => {
  return [
    {
      label: strings.beo_venue_details,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'bookingLineItemId',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      options: lineItemsList,
    },
    {
      label: strings.beo_function_time_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'timeSlot',
      validators: [{ check: Validators.validateInt }],
      responsive: { xs: 12 },
      required: false,
      disabled: true,
    },
    {
      label: strings.add_rfq_text_event_type,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'eventType',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12 },
      required: false,
      disabled: true,
    },
    {
      label: strings.new_booking_event_sub_type,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'eventSubtype',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12 },
      required: false,
      disabled: true,
    },
    {
      label: strings.beo_guaranteed_guests_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'guaranteedGuests',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt }],
      responsive: { xs: 12 },
      required: true,
      disabled: true,
    },
    {
      label: strings.beo_setup_text,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'layoutId',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      options: layoutList,
      disabled: true,
    },
  ];
};
